import request from '@/utils/request'
const BASE_URL = '/pdd/logistics'

export default {
  // 拼多多 店铺可用的快递公司列表获取
  companies(mallId = null) {
    var headers = {};
    if (mallId) headers['mallid'] = mallId;
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    return request({
      url: BASE_URL + '/companies',
      method: 'get',
      headers: headers
    })
  },
  // 拼多多 店铺可用的发货地址列表获取
  senderaddresses(code, mallId = null) {
    var headers = {};
    if (mallId) headers['mallid'] = mallId;
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    return request({
      url: BASE_URL + '/senderaddresses?wpcode=' + code,
      method: 'get',
      headers: headers
    })
  },
  // 拼多多 快递公司标准电子面单模板列表获取
  standardtemplates(code, mallId = null) {
    return request({
      url: BASE_URL + '/standardtemplates?wpcode=' + code,
      method: 'get'
    })
  },
  fetchCompanies(mallId = null) {
    // if (token) request.defaults.headers['Authorization'] = "Bearer " + token;
    return request({
      url: BASE_URL + '/fetch',
      method: 'post'
    })
  },
  // 拼多多 快递公司自定义电子面单模板列表获取
  getCustomtemplates() {
    return request({
      url: BASE_URL + '/customtemplates',
      method: 'get'
    })
  },
  // 拼多多 创建快递公司自定义电子面单模板
  postCustomtemplates(data) {
    return request({
      url: BASE_URL + '/customtemplates',
      method: 'post',
      data
    })
  },
  // 拼多多 订单发货
  postSendonline(data, mallId = null) {
    return request({
      url: BASE_URL + '/sendonline',
      method: 'post',
      data
    })
  },
}